/* KartComms — B2B Quote page. Honeypot + no-reload submit with a success-panel swap.
   The form is fully functional without JS (native Shopify contact form post). */
(function () {
  'use strict';
  var root = document.getElementById('kc-quote');
  if (!root) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var form = root.querySelector('[data-kcq-form]');
  if (!form) return;

  // If the server round-tripped a success message, bring it into view.
  var serverOk = form.querySelector('[data-form-ok]');
  if (serverOk) serverOk.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });

  form.addEventListener('submit', function (e) {
    var hp = form.querySelector('input[name="contact[website]"]');
    if (hp && hp.value) { e.preventDefault(); return; }   // bot caught by honeypot
    if (!form.checkValidity()) return;                     // let the browser surface field errors + native submit
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = form.getAttribute('data-sending') || 'Sending…'; }

    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
      .then(function () {
        var fields = form.querySelector('[data-form-fields]');
        var ok = document.createElement('p');
        ok.className = 'kcq-form__ok';
        ok.setAttribute('role', 'status');
        ok.textContent = form.getAttribute('data-success') || 'Thanks — your quote request is in.';
        form.insertBefore(ok, fields);
        if (fields) fields.classList.add('is-hidden');
        ok.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      })
      .catch(function () {
        // Network failure — restore the button and fall back to a real form post.
        if (btn) { btn.disabled = false; btn.textContent = label; }
        form.submit();
      });
  });
})();
